import loc from 'owa-localize';
import GroupFolderAction from './GroupFolderAction';
import { HttpStatusCode } from 'owa-http-status-codes';
import { EmptyResponseError } from '../strings/ErrorMessages.locstring.json';
import { renameFolderWithNameAlreadyExists } from 'owa-locstrings/lib/strings/renameFolder.locstring.json';

export default function getErrorMessage(
    action: GroupFolderAction,
    statusCode: number,
    response: any
): string {
    let errorMessage = '';
    if (action === GroupFolderAction.RenameFolder && statusCode === HttpStatusCode.BadRequest) {
        errorMessage = loc(renameFolderWithNameAlreadyExists);
    } else {
        errorMessage = response?.error?.message ?? loc(EmptyResponseError);
    }
    return errorMessage;
}
